import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { ProviderShell } from "@/components/provider/ProviderShell";
import { ProviderInvoicesPanel } from "@/components/ProviderPortalControls";

const money = (value) => `$${Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;

export default function ProviderTimeAndPayPage() {
  const [data, setData] = useState(null);
  const [queue, setQueue] = useState(null);
  const [error, setError] = useState("");
  const [showInvoices, setShowInvoices] = useState(false);
  useEffect(() => {
    api.get("/providers/me/time-and-pay").then((response) => setData(response.data)).catch((requestError) => setError(formatApiError(requestError)));
  }, []);
  useEffect(() => {
    if (showInvoices && !queue) api.get("/providers/me/work-queue").then((response) => setQueue(response.data)).catch(() => setQueue(null));
  }, [showInvoices, queue]);
  return (
    <ProviderShell title="Time and pay" eyebrow="YOUR OWN AMOUNTS ONLY" testId="provider-pay-page">
      {error && <p className="form-message error-message" data-testid="provider-pay-error">{error}</p>}
      {data && (
        <>
          {data.pay_dates.map((pay) => (
            <section key={pay.kind} className={`provider-card provider-next-pay ${pay.kind}`} data-testid={`provider-next-pay-${pay.kind}`}>
              <p className="eyebrow">{pay.kind === "evaluations" ? "NEXT PAY DATE · EVALUATIONS AND SCREENINGS" : "NEXT PAY DATE · HOURLY WORK"}</p>
              <strong>{pay.pays_on_label}</strong>
              <p className="muted">{pay.note}</p>
            </section>
          ))}
          {data.hours && (
            <a className="provider-card provider-link-card" data-testid="provider-hours-link" href={data.hours.url} target="_blank" rel="noreferrer">
              <div><strong>{data.hours.label}</strong><span className="muted">{data.hours.meta}</span></div>
              <em>Open ›</em>
            </a>
          )}
          <section className="provider-card" data-testid="provider-pay-history">
            <h2>{data.history_title}</h2>
            {data.history.length === 0 && <p className="muted">No completed work in this period yet.</p>}
            {data.history.map((row) => (
              <Link key={row.id} className="provider-pay-row" data-testid={`provider-pay-row-${row.id}`} to={`/provider-portal/work/${row.id}`}>
                <div><strong>{row.title}</strong><span>{row.meta}</span></div>
                <div className="pay-amount"><strong>{money(row.amount)}</strong><em className={row.status === "Paid" ? "paid" : ""}>{row.status}</em></div>
              </Link>
            ))}
            {data.history.length > 0 && <small className="muted" data-testid="provider-pay-rule">{data.pay_rule}</small>}
          </section>
          {data.show_invoices && (
            <>
              <button className="provider-card provider-link-card" data-testid="provider-invoices-link" type="button" onClick={() => setShowInvoices((current) => !current)}>
                <div><strong>Invoices</strong><span className="muted">Create or upload your 1099 invoice</span></div>
                <em>{showInvoices ? "Hide" : "Open ›"}</em>
              </button>
              {showInvoices && queue && <ProviderInvoicesPanel queue={queue} onReload={() => api.get("/providers/me/work-queue").then((response) => setQueue(response.data))} />}
            </>
          )}
          <a className="ghost-button provider-message" data-testid="provider-ask-payment" href="mailto:info@theallicockgroup.com?subject=Question%20about%20a%20payment">Ask about a payment</a>
          <p className="muted" data-testid="provider-pay-note">Questions about a payment? Use the button above and include the evaluation, not the student's name.</p>
        </>
      )}
    </ProviderShell>
  );
}
